import { MutableRefObject, useEffect, useState } from 'react';
import { ChartApi } from '@/components';

function gridRectFromEChart(chartApi: ChartApi) {
  // using internal echarts API https://github.com/apache/echarts/issues/16480
  return chartApi.getChartModel().getComponent('grid').coordinateSystem.getRect();
}

// returns coordinates for the grid area within an ECharts instance
export function useEChartsGridCoordinates(chartApiRef: MutableRefObject<ChartApi | undefined>) {
  const [gridRect, setGridRect] = useState<{ x: number; y: number; width: number; height: number }>();

  useEffect(() => {
    chartApiRef.current?.on('finished', () => {
      // on chart re-render
      if (chartApiRef.current) {
        setGridRect(gridRectFromEChart(chartApiRef.current));
      }
    });

    // on ref change
    if (chartApiRef.current) {
      setGridRect(gridRectFromEChart(chartApiRef.current));
    }
  }, [chartApiRef]);

  return gridRect;
}
